import { combineReducers } from 'redux';

import { commonReducer, commonName } from './common';
import { transactionReducer, transactionName } from './transaction';
import { audienceReducer, audienceName } from './audience';
import { staffName, staffReducer } from 'modules/staff/state';
import { userReducer, userName } from 'modules/user/state';
import { filterRd, filterName } from 'hooks/withFilter';

export default combineReducers({
  [commonName]: commonReducer,
  [transactionName]: transactionReducer,
  [audienceName]: audienceReducer,
  [staffName]: staffReducer,
  [userName]: userReducer,
  [filterName]: filterRd,
});
